<template>
  <span>
    <AppFormItem label="Status">
      <AutoComplete
        :modelValue="status"
        @update:modelValue="onChange($event)"
        :suggestions="bovineStatusAvailable"
        @complete="onSearchStatus($event)"
        field="name"
        dropdown
      ></AutoComplete>
    </AppFormItem>
    <Dialog
      header="Previsão de parto"
      v-model:visible="childBirthDialog.visible"
      :style="{ width: '35vw' }"
      :modal="true"
      :closable="false"
    >
      <span v-if="childBirthDialog.service">
        <p>O bovino possui o seguinte serviço:</p>
        <p>
          <ServiceType
            :value="childBirthDialog.serviceText"
            :background="childBirthDialog.service.type.color"
          ></ServiceType>
        </p>
        <p>
          Você gostaria de calcular a data de previsão de parto a partir da data
          inicial do serviço?
        </p>
      </span>
      <span v-else>
        <p>
          Você não possui serviço configurado para calcular a previsão de parto,
          vamos preencher a data a partir do dia de hoje.
        </p>
      </span>
      <template #footer>
        <div v-if="childBirthDialog.service" class="p-grid p-jc-between">
          <div class="p-ml-2">
            <Checkbox
              name="defaultChildBirth"
              v-model="childBirthDialog.default"
              :binary="true"
            />
            <label class="p-ml-2" for="defaultChildBirth">Definir resposta como padrão</label>
          </div>
          <div style="padding-right: 8px">
            <Button
              label="Não"
              class="p-button-outlined p-mr-2"
              @click="calculateChildBirthFromToday()"
            />
            <AppButton label="Sim" @click="calculateChildBirthFromService()" />
          </div>
        </div>
        <div v-else class="p-grid p-jc-end">
          <Button
            label="OK"
            class="p-button-outlined"
            @click="calculateChildBirthFromToday()"
          />
        </div>
      </template>
    </Dialog>
  </span>
</template>

<script>
import ServiceType from '../../Service/components/ServiceType';
import { BovineApi } from '../../../services/api';

export default {
  name: 'BovineEditStatus',
  props: {
    id: Number,
    status: Object,
    statusId: Number,
    typeId: Number,
    childBirth: Object,
    services: Object,
  },
  components: {
    ServiceType,
  },
  data() {
    return {
      bovineStatus: [],
      childBirthDialog: {
        visible: false,
        service: null,
        serviceText: null,
        default: false
      },
    };
  },
  watch: {
    typeId() {
      const bovineStatus = this.bovineStatusAvailable.find(
        (status) => status.id === this.statusId
      );
      if (!bovineStatus) {
        this.$emit('update:status', null);
        this.$emit('update:statusId', null);
      }
    },
  },
  computed: {
    bovineStatusAvailable() {
      return this.bovineStatus.filter((bovineStatus) =>
        bovineStatus.types.some(({ typeId }) => typeId === this.typeId)
      );
    },
  },
  methods: {
    async onSearchStatus({ query: name }) {
      const { results: bovineStatus } = await BovineApi.fetchStatus({
        order: 'asc',
        orderField: 'name',
        name,
      });
      this.bovineStatus = bovineStatus;
    },
    onChange(event) {
      this.$emit('update:status', event);
      this.$emit('update:statusId', event?.id || null);
      if (event?.id === 2) {
        this.showChildBirthDialog();
      } else {
        this.$emit('update:childBirth', null);
      }
    },
    showChildBirthDialog() {
      if (!this.id) {
        this.calculateChildBirthFromToday();
        return;
      }

      this.childBirthDialog.visible = false;
      this.childBirthDialog.service = null;
      this.childBirthDialog.serviceText = null;
      this.childBirthDialog.default = false;

      const service = this.services.find((service) => {
        return service?.type?.calcChildBirth;
      });

      if (!service) {
        this.childBirthDialog.visible = true;
        return;
      }

      let serviceText = `#${service.id} ${
        service.type.name
      } - ${this.$formatDate(service.dateStart)}`;
      if (service.dateEnd) {
        serviceText += ` a ${this.$formatDate(service.dateEnd)}`;
      }

      this.childBirthDialog.service = service
      this.childBirthDialog.serviceText = serviceText;

      const defaultChildBirth = this.getDefaultChildBirth()
      if (defaultChildBirth === 'today') {
        this.calculateChildBirthFromToday();
        return;
      }
      if (defaultChildBirth === 'service') {
        this.calculateChildBirthFromService();
        return;
      }

      this.childBirthDialog.visible = true;
    },
    calculateChildBirthFromToday() {
      this.$emit('update:childBirth', this.$dayjs().add(9, 'month').toDate());
      this.childBirthDialog.visible = false;
      if (this.childBirthDialog.service && this.childBirthDialog.default) {
        this.setDefaultChildBirth('today')
      }
    },
    calculateChildBirthFromService() {
      const dateStart = new Date(this.childBirthDialog.service.dateStart);
      this.$emit(
        'update:childBirth',
        this.$dayjs(dateStart).add(9, 'month').toDate()
      );
      this.childBirthDialog.visible = false;
      if (this.childBirthDialog.service && this.childBirthDialog.default) {
        this.setDefaultChildBirth('service')
      }
    },
    setDefaultChildBirth(value) {
      localStorage.setItem('preferences.calcChildBirth', value)
    },
    getDefaultChildBirth() {
      return localStorage.getItem('preferences.calcChildBirth')
    }
  },
};
</script>

<style>
</style>
